import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, MessageSquareIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const MaatwerkAdviesPage = () => {
  return <main data-id="element-1016" data-mp="6idhvmcyf5j1">
      <SEO title="Maatwerk Advies | Persoonlijk Styling Advies | BKCustoms" description="Op zoek naar een unieke styling oplossing? Wij bieden persoonlijk advies en maatwerk voor uw specifieke wensen en auto bij BKCustoms in Almere. Vrijblijvend advies." canonical="/diensten/maatwerk-advies" data-id="element-1017" data-mp="6i55dvkqu28d" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-1018" data-mp="q5b7fzwsg9t0">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1019" data-mp="q3rmhw06takw">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-1020" data-mp="l6rirrqt8jwy"></div>
          <img src="https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80" alt="Maatwerk Advies" className="w-full h-full object-cover object-center" data-id="element-1021" data-mp="l8kp15xih24f" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1022" data-mp="2dq1mvk5jnvvk">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1023" data-mp="2dnxk55jdt2wv">
            Maatwerk <span className="text-[#D6281F]" data-id="element-1024" data-mp="1zsmt6389d1xs">Advies</span>
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1025" data-mp="24oahyhitvt2r">
            Op zoek naar een unieke styling oplossing? Wij bieden persoonlijk
            advies en maatwerk voor uw specifieke wensen en auto.
          </p>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1026" data-mp="1h12i4f465c84">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1027" data-mp="1gy7uyftrtdb0">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-1028" data-mp="1l2fmslviz9dg">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-1029" data-mp="172mwusrtox6j">
              <div className="relative" data-id="element-1030" data-mp="1c1he3qa56doj">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1031" data-mp="1c0ervvnrkzey"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1032" data-mp="38znd5dr9x1nc">
                  <img src="https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80" alt="Maatwerk advies voor car styling" className="w-full h-auto object-cover" data-id="element-1033" data-mp="34xa9qw001ftq" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-1034" data-mp="3nmqclpz5pkdb">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1035" data-mp="3ipgoqerf1grl">
                Persoonlijk Styling Advies
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1036" data-mp="2c9xlmhe6wzyb">
                Bij BKCustoms begrijpen we dat elke auto en elke eigenaar uniek
                is. Daarom bieden we maatwerk advies om de perfecte styling
                oplossing voor uw specifieke wensen en voertuig te creëren.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-1037" data-mp="225hbm4ne6d2f">
                Of u nu op zoek bent naar een subtiele verbetering of een
                complete transformatie, onze experts staan klaar om u te
                adviseren over de beste opties en combinaties van onze diensten.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1038" data-mp="2fyyudn897lre">
                <div className="flex items-center" data-id="element-1039" data-mp="2kunrljwswqkj">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1040" data-mp="2puscdm4qs7gk">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1041" data-mp="2pvk0kbw0f2wt" />
                  </div>
                  <span className="text-white/90" data-id="element-1042" data-mp="2ut3m7wv1ehys">
                    Persoonlijke consultatie met styling experts
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1043" data-mp="10f2esnlf8mn3">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1044" data-mp="10hydwf909hd4">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1045" data-mp="2qveeo3puznr6" />
                  </div>
                  <span className="text-white/90" data-id="element-1046" data-mp="2lx36dxf7plb2">
                    Op maat gemaakte styling voorstellen
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1047" data-mp="2uysvuxpjaa67">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1048" data-mp="2uz2oyu5vkxg4">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1049" data-mp="27a05dgrokuiz" />
                  </div>
                  <span className="text-white/90" data-id="element-1050" data-mp="2386bpsfwkqsb">
                    Combinaties van verschillende diensten
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1051" data-mp="2h0mi9380j6xz">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1052" data-mp="2c70anpgpht91">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1053" data-mp="1ohyxxq0ubvxy" />
                  </div>
                  <span className="text-white/90" data-id="element-1054" data-mp="1jjnsrslhq9m2">
                    Transparante prijsopgave zonder verrassingen
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1055" data-mp="3s1xz6gdp0fa">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1056" data-mp="3tms4uys6hcm">
                  <span className="mr-2" data-id="element-1057" data-mp="ip2oj6mu2pc6">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-1058" data-mp="mqxr0egi38rj" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1059" data-mp="mq4u057cfxml">
                  Contact opnemen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Process Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-1060" data-mp="2ee44vueas0nw">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1061" data-mp="2eduiegsgobmy">
          <div className="text-center mb-16" data-id="element-1062" data-mp="2ac8y4adlkv2q">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1063" data-mp="2adka2xh7594x">
              Ons <span className="text-[#D6281F]" data-id="element-1064" data-mp="25kr4k7dwlwrs">Proces</span>
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1065" data-mp="20nr0u34j163u">
              Bij BKCustoms volgen we een zorgvuldig proces om tot de perfecte
              maatwerk oplossing te komen.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-1066" data-mp="1qo05y0c20p38">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-1067" data-mp="1mmoahe6i19n4">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-1068" data-mp="1hod0n3g7ez4w">
                1
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-1069" data-mp="3gyuyjdkhrkwu">
                Consultatie
              </h3>
              <p className="text-white/80" data-id="element-1070" data-mp="3jlwz9697vu09">
                We beginnen met een uitgebreid gesprek over uw wensen,
                voorkeuren en budget om uw visie volledig te begrijpen.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-1071" data-mp="3tb6tarnmfmr0">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-1072" data-mp="25nhlolm7nhi">
                2
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-1073" data-mp="35lm8s4btkhfm">Advies</h3>
              <p className="text-white/80" data-id="element-1074" data-mp="35np9biallsyl">
                Onze experts stellen verschillende opties voor, inclusief
                visualisaties en gedetailleerde uitleg van de mogelijkheden.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-1075" data-mp="pv9g09u5xyog">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-1076" data-mp="tw1q15av07ls">
                3
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-1077" data-mp="1fviswmhp8pih">
                Plan van Aanpak
              </h3>
              <p className="text-white/80" data-id="element-1078" data-mp="1pnevoauqd3t1">
                We ontwikkelen een gedetailleerd plan inclusief tijdlijn,
                materialen en een transparante prijsopgave.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-1079" data-mp="1ynk1igk9zu53">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-1080" data-mp="1tpryaqe6klll">
                4
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-1081" data-mp="23ng4cch8lfj2">
                Uitvoering
              </h3>
              <p className="text-white/80" data-id="element-1082" data-mp="e7zwr1iyo1va">
                Na uw goedkeuring voeren we het project uit met de hoogste
                aandacht voor detail en kwaliteit, met regelmatige updates.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Options Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1083" data-mp="2pwd3c9okaog0">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1084" data-mp="2pv20cc2xxkpy">
          <div className="text-center mb-16" data-id="element-1085" data-mp="2b7qrwj222gu2">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1086" data-mp="2b4utktmapq53">
              Populaire <span className="text-[#D6281F]" data-id="element-1087" data-mp="2g4h2wrz06m8m">Combinaties</span>
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1088" data-mp="225hhdt6sengo">
              Ontdek enkele van onze meest gevraagde styling combinaties die we
              voor klanten hebben gerealiseerd.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1089" data-mp="1s9xqjl72yeys">
            <div className="bg-[#0f0f0f] border border-[#222] p-8 rounded-lg" data-id="element-1090" data-mp="1x88whku985bq">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1091" data-mp="3mlm35gpua5g0">
                Sport Package
              </h3>
              <p className="text-white/80 mb-6" data-id="element-1092" data-mp="3rk5slr3n5zd4">
                Een complete sportieve upgrade met een combinatie van lichten
                smoken, ramen tinten en ontchromen voor een krachtige
                uitstraling.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-1093" data-mp="3c9vobegz5e21">
                <li className="flex items-center text-white/80" data-id="element-1094" data-mp="2yh5uinv7f4ud">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1095" data-mp="33fh2et1xv59y" />
                  Lichten smoken (voor- en achterlichten)
                </li>
                <li className="flex items-center text-white/80" data-id="element-1096" data-mp="3r6d026t2sup4">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1097" data-mp="3v75cta15phq5" />
                  Premium ramen tinting
                </li>
                <li className="flex items-center text-white/80" data-id="element-1098" data-mp="3h62o0pis1tbj">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1099" data-mp="3m5fk80vjgcqs" />
                  Complete chrome delete
                </li>
              </ul>
            </div>
            <div className="bg-[#0f0f0f] border border-[#222] p-8 rounded-lg" data-id="element-1100" data-mp="25u1vczislkqi">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1101" data-mp="2as3etlk4rm2i">
                Premium Bescherming
              </h3>
              <p className="text-white/80 mb-6" data-id="element-1102" data-mp="2393wzkcbi2l9">
                Maximale bescherming voor uw auto met een combinatie van
                beschermende wraps en AlloyGator velgbescherming.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-1103" data-mp="278usg1csh6w4">
                <li className="flex items-center text-white/80" data-id="element-1104" data-mp="27a5wm2a5cgnr">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1105" data-mp="1jj0fljsgzibv" />
                  Transparante beschermfolie op kwetsbare delen
                </li>
                <li className="flex items-center text-white/80" data-id="element-1106" data-mp="1fjj8yn1b4f54">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1107" data-mp="1ta4vclpyz77r" />
                  AlloyGator velgbescherming
                </li>
                <li className="flex items-center text-white/80" data-id="element-1108" data-mp="1oga3gv07nlxl">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1109" data-mp="10rqxwn8jpn97" />
                  UV-werende ramen tinting
                </li>
              </ul>
            </div>
            <div className="bg-[#0f0f0f] border border-[#222] p-8 rounded-lg" data-id="element-1110" data-mp="2vwgsh7n1r6ym">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1111" data-mp="30v1th9a4huo4">
                Complete Transformatie
              </h3>
              <p className="text-white/80 mb-6" data-id="element-1112" data-mp="35l8hb6wt9b5b">
                Een volledige makeover voor uw auto met een premium wrap,
                getinte ramen en gesmokte lichten voor een unieke look.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-1113" data-mp="2cxw0zeh8tzkg">
                <li className="flex items-center text-white/80" data-id="element-1114" data-mp="2cz7aluxde1jh">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1115" data-mp="2hwz06iajlbki" />
                  Volledige auto wrap in kleur naar keuze
                </li>
                <li className="flex items-center text-white/80" data-id="element-1116" data-mp="2qwvtwybsh0mf">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1117" data-mp="2qy6w4tpl60bf" />
                  Complete ramen tinting
                </li>
                <li className="flex items-center text-white/80" data-id="element-1118" data-mp="66mzhb8wr2iv">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-1119" data-mp="64tppn30026n" />
                  Lichten smoken en ontchromen
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-1120" data-mp="1hvu7x3b56ttm">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1121" data-mp="1huiyonyxgtv4">
          <div className="text-center mb-16" data-id="element-1122" data-mp="1cy2da1j44tlq">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1123" data-mp="1cv6eyc3cs2wr">
              Wat Onze <span className="text-[#D6281F]" data-id="element-1124" data-mp="17zhc9zw1e5w8">Klanten</span> Zeggen
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1125" data-mp="12ybkq5e44ooa">
              Ontdek de ervaringen van klanten die gebruik hebben gemaakt van
              ons maatwerk advies.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1126" data-mp="u09ar0ceilov">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1127" data-mp="2tbsgz76blfuu">
              <div className="flex items-center mb-4" data-id="element-1128" data-mp="2ocpg7yxdhvso">
                <MessageSquareIcon size={20} className="text-[#D6281F] mr-3" data-id="element-1129" data-mp="2od7gd6n5ou5v" />
                <div className="flex space-x-1" data-id="element-1130" data-mp="1l2toksmn5oq9">
                  {[...Array(5)].map((_, i) => <div key={i} className="text-[#D6281F]" data-id="element-1131" data-mp="1pzbnhbvaisuo" data-mpi={i}>
                      ★
                    </div>)}
                </div>
              </div>
              <p className="text-white/80 italic mb-6" data-id="element-1132" data-mp="1gz5h09y0et50">
                "De persoonlijke aanpak van BKCustoms heeft me echt geholpen bij
                het maken van de juiste keuzes voor mijn BMW. Hun advies was op
                maat en het eindresultaat overtrof mijn verwachtingen!"
              </p>
              <div className="flex items-center" data-id="element-1133" data-mp="tb5ignughyfv">
                <div className="mr-3 w-10 h-10 rounded-full bg-[#222] flex items-center justify-center text-white font-bold" data-id="element-1134" data-mp="t8j8khk3f6uh">
                  M
                </div>
                <div data-id="element-1135" data-mp="jdhmjul46kw4">
                  <div className="text-white font-medium" data-id="element-1136" data-mp="je9g6zv5i8jr">Mark de Vries</div>
                  <div className="text-white/60 text-sm" data-id="element-1137" data-mp="oaq3jruj0ivs">BMW M4 eigenaar</div>
                </div>
              </div>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1138" data-mp="4rapj744bi63">
              <div className="flex items-center mb-4" data-id="element-1139" data-mp="3vxlp0ythcavb">
                <MessageSquareIcon size={20} className="text-[#D6281F] mr-3" data-id="element-1140" data-mp="enx9zusj877l" />
                <div className="flex space-x-1" data-id="element-1141" data-mp="9ou2m3p2xowg">
                  {[...Array(5)].map((_, i) => <div key={i} className="text-[#D6281F]" data-id="element-1142" data-mp="no281ebu5t93" data-mpi={i}>
                      ★
                    </div>)}
                </div>
              </div>
              <p className="text-white/80 italic mb-6" data-id="element-1143" data-mp="in61et03nszz">
                "Ik wist niet precies wat ik wilde voor mijn auto, maar dankzij
                het maatwerk advies van BKCustoms heb ik nu een unieke look die
                perfect bij mijn stijl past. Zeer tevreden!"
              </p>
              <div className="flex items-center" data-id="element-1144" data-mp="16cqpfqb41gg4">
                <div className="mr-3 w-10 h-10 rounded-full bg-[#222] flex items-center justify-center text-white font-bold" data-id="element-1145" data-mp="12e13vafx4sle">
                  L
                </div>
                <div data-id="element-1146" data-mp="1efiwwc575nd1">
                  <div className="text-white font-medium" data-id="element-1147" data-mp="1eepwdswtzu3c">Laura Jansen</div>
                  <div className="text-white/60 text-sm" data-id="element-1148" data-mp="1jem2bxp39vlj">Audi A5 eigenaar</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-1149" data-mp="1s762x3oxya90">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-1150" data-mp="1s90cxmyochyb">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1151" data-mp="1x4petwy62axs">
            Klaar voor uw persoonlijke styling advies?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-1152" data-mp="2230uiob57fnx">
            Neem contact met ons op voor een vrijblijvende consultatie of maak
            direct een afspraak voor een persoonlijk gesprek.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1153" data-mp="7tf8pf1d1mch">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-1154" data-mp="cqp3zbbfks88">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-1155" data-mp="2h7bwl7xgcy6g">
              Vraag ons advies
            </Link>
          </div>
        </div>
      </section>
    </main>;
};